import Wikis from '~/pages/shared/wikis/wikis';

export default new Wikis();
